import { StyleSheet } from "@react-pdf/renderer";
import { blue, white } from "./PDFColors";

export const styles = StyleSheet.create({
  backgroundBlue: {
    height: "100%",
    width: "100%",
    borderStyle: "solid",
    borderColor: blue,
    borderWidth: "10pt",
  },

  marginTop11: {
    marginTop: "11px",
  },

  callOptionContainer: {
    width: "100%",
    height: "100%",
    justifyContent: "center",
    alignItems: "center",
  },

  callOptionBox: {
    width: "90%",
    height: "88%",
    borderStyle: "solid",
    borderColor: blue,
    borderWidth: "1pt",
  },

  titleBox: {
    height: "10%",
    width: "100%",
    borderBottomStyle: "solid",
    borderBottomColor: blue,
    borderBottomWidth: "1pt",
    justifyContent: "center",
    alignItems: "center",
    backgroundColor: blue,
  },

  textTitle: { color: white, fontSize: "14px" },

  infoBox: {
    height: "33%",
    width: "100%",
    borderBottomStyle: "solid",
    borderBottomColor: blue,
    borderBottomWidth: "1pt",
    justifyContent: "center",
    alignItems: "center",
    display: "flex",
    flexDirection: "row",
  },

  infoBoxLeft: {
    height: "100%",
    width: "65%",
    padding: "10px",
  },

  infoBoxRight: {
    height: "100%",
    width: "35%",
    padding: "10px",
  },

  infoBoxLeftTextUpperBox: { height: "80%", width: "100%" },
  infoBoxLeftTextLowerBox: { height: "20%", width: "100%" },

  textInfoBox: { textAlign: "left", fontSize: "12px", marginVertical: "2px" },

  leaverEventsBox: {
    height: "45%",
    width: "100%",
    borderBottomStyle: "solid",
    borderBottomColor: blue,
    borderBottomWidth: "1pt",
    justifyContent: "center",
    alignItems: "center",
    display: "flex",
    flexDirection: "row",
  },

  leaverEventsBoxSubTitle: {
    height: "15%",
    width: "100%",
  },

  leaverEventsBoxTextPairLeft: {
    width: "100%",
    height: "33%",
    display: "flex",
    flexDirection: "column",
  },

  leaverEventsBoxTextPairRight: {
    width: "100%",
    height: "33%",
    display: "flex",
    flexDirection: "column",
  },

  leaverEventsBoxLeft: {
    height: "100%",
    width: "40%",
    borderRightStyle: "solid",
    borderRightColor: blue,
    borderRightWidth: "0.5pt",
    padding: "10px",
    display: "flex",
    flexDirection: "column",
  },

  leaverEventsBoxColumns: {
    height: "100%",
    width: "100%",
    display: "flex",
    flexDirection: "row",
  },

  leaverEventsBoxLeftLeft: {
    height: "100%",
    width: "50%",
    alignItems: "center",
  },

  textLeaverEventsBoxLeftLeft: {
    textAlign: "left",
    fontSize: "17px",
    marginVertical: "20px",
    fontWeight: "bold",
  },

  leaverEventsBoxLeftRight: {
    height: "100%",
    width: "50%",
    justifyContent: "center",
    alignItems: "center",
    marginTop: "19px",
  },

  textLeaverEventsBoxLeftRight: {
    textAlign: "left",
    fontSize: "15px",
    marginVertical: "2px",
  },

  leaverEventsBoxRight: {
    height: "100%",
    width: "60%",
    borderLeftStyle: "solid",
    borderLeftColor: blue,
    borderLeftWidth: "0.5pt",
    padding: "10px",
    paddingBottom: "5px",
  },

  leaverEventsBoxRightContent: {
    height: "100%",
    width: "100%",
    marginTop: "20px",
  },

  textLeaverEventsBoxRightContent: {
    textAlign: "left",
    fontSize: "12px",
    marginVertical: "2px",
  },

  textLeaverTitle: {
    textAlign: "center",
    fontSize: "17px",
    textDecoration: "underline",
  },

  afterVestingInfoBox: {
    height: "5%",
    width: "100%",
    borderBottomStyle: "solid",
    borderBottomColor: blue,
    borderBottomWidth: "1pt",
    justifyContent: "center",
    alignItems: "center",
    backgroundColor: blue,
  },

  textAfterVestingInfo: { textAlign: "left", fontSize: "13px", color: white },

  afterVestingContentBox: {
    height: "7%",
    width: "100%",
    borderBottomStyle: "solid",
    borderBottomColor: blue,
    borderBottomWidth: "1pt",
    justifyContent: "center",
    alignItems: "center",
    display: "flex",
    flexDirection: "row",
  },

  afterVestingContentBoxLeft: {
    height: "100%",
    width: "40%",
    borderRightStyle: "solid",
    borderRightColor: blue,
    borderRightWidth: "0.5pt",
    display: "flex",
    flexDirection: "row",
  },

  afterVestingContentBoxLeftLeft: {
    height: "100%",
    width: "50%",
    justifyContent: "center",
    alignItems: "center",
  },

  textAfterVestingContentBoxLeftLeft: {
    textAlign: "left",
    fontSize: "17px",
    fontWeight: "bold",
  },

  afterVestingContentBoxLeftRight: {
    height: "100%",
    width: "50%",
    textAlign: "center",
    justifyContent: "center",
  },

  textAfterVestingContentBoxLeftRight: {
    textAlign: "left",
    fontSize: "15px",
    marginVertical: "2px",
  },

  afterVestingContentBoxRight: {
    height: "100%",
    width: "60%",
    borderLeftStyle: "solid",
    borderLeftColor: blue,
    borderLeftWidth: "0.5pt",
    justifyContent: "center",
    alignContent: "center",
    paddingLeft: "10px",
  },

  textSideNote: {
    fontSize: "13px",
    textDecoration: "underline",
    marginTop: "2px",
  },

  text: { textAlign: "left", fontSize: "14px" },
});
